// This controller borrows from toggle_controller.js and does some additional stuff specific to
// range-select.

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["display", "overlay", "content", "atLeast", "atMost"];

  connect() {
    this.update();
  }

  toggle(e) {
    // There's a limitation in height animations, which is nothing to do with Tailwind, just CSS.
    // If you want to animate, you have to have a specific start and end size.  To make this happen
    // We use an arbitrarily large max-height which should be big enough to accommodate the content.
    this.contentTarget.classList.toggle("max-h-0");
    this.contentTarget.classList.toggle("max-h-[1000px]");

    this.overlayTarget.classList.toggle("hidden");
  }

  update(e) {
    var display = "";

    if (this.atLeastTarget.value != "" && this.atMostTarget.value != "") {
      display = this.atLeastLabel() + " - " + this.atMostLabel();
    } else if (this.atLeastTarget.value != "") {
      display = "At least " + this.atLeastLabel();
    } else if (this.atMostTarget.value != "") {
      display = "Up to " + this.atMostLabel();
    } else {
      display = "All";
    }

    this.displayTarget.value = display;
  }

  atLeastLabel() {
    return this.atLeastTarget.options[this.atLeastTarget.selectedIndex].text;
  }

  atMostLabel() {
    return this.atMostTarget.options[this.atMostTarget.selectedIndex].text;
  }
}
